import React, { useState, useEffect } from 'react';
import { Box, Button, MenuItem, Select, TextField, IconButton, Alert } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import InputAdornment from '@mui/material/InputAdornment';
import SearchBar from '../../components/SearchBar';
import { useTheme, useMediaQuery } from '@mui/material';
import { useNavigate } from "react-router-dom";
import Nodata from "utils/components/nodata-v1"

import { ApiFindHospital, ApiFindDepartment, ApiFindDocument, ApiUploadExcel, ApiFindDropdownList } from 'utils/api/data';
import {
  ApiDataImport,
  ApiFindDataRecord,
  ApiFindDropdown,
  ApiFindCheckList,
  ApiImportHistory,
  ApiClearHistory,
} from 'utils/api/analytics'

import { ApiExportExcel }
  from 'utils/api/export'

// import TableCustom from 'utils/components/table-custom'
import TableCustom from 'utils/components/table-custom-v1'


import DialogAlert from 'utils/components/modal-alert'
import DialogSubmit from 'utils/components/modal-submit'


const defaultValues = {
  defaultValues: {

    hospital_code: '',
    hospital_name: '',

    department_code: '',
    department_name: '',

  }
}


const selectStyles = {
  backgroundColor: '#C8EBEB',
  border: 'none',
  '.MuiOutlinedInput-notchedOutline': { borderColor: '#C8EBEB' },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#C8EBEB' },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#C8EBEB' },
};




function ImportHealthData() {

  const navigate = useNavigate()
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const [openAlert, setOpenAlert] = useState(false)
  const [alertType, setAlertType] = useState('')
  const handleOpenAlert = (type) => {
    setOpenAlert(type)
  }
  const [openSubmit, setOpenSubmit] = useState(false)
  const [typeSubmit, setTypeSubmit] = useState('')
  const [dataSubmit, setDataSubmit] = useState(null)
  const handleOpenSubmit = async (type, reset, payload) => {
    setOpenSubmit(type)
    if (reset) {
      let result = await ApiClearHistory(payload)
      if (result.status) {
        setLoading(false)
        fetchDataImport()
        setMessageAlert('สำเร็จ')
        setAlertType('success')
        handleOpenAlert(true)
        setErrorMessage('');
        setTimeout(() => {
          handleOpenAlert(false)
          setMessageAlert('')
          setAlertType('')
        }, 2000);

      }
      setTypeSubmit('')
    }
  }

  const [messageAlert, setMessageAlert] = useState('')
  const [loading, setLoading] = useState(false)

  const [fileName, setFileName] = useState('');
  const [file, setFile] = useState('');

  const [errorMessage, setErrorMessage] = useState('');
  const [alertData, setAlertData] = useState([]);

  const [findHospital, setFindHospital] = useState([])
  const [findYear, setFindYear] = useState([])
  const [findInspectionRound, setFindInspectionRound] = useState([])
  const [findDepartment, setFindDepartment] = useState([])
  const [findExport, setFindExport] = useState([])

  const [hospital, setHospital] = useState('')

  const [filterHospital, setFilterHospital] = useState('all')
  const [filterDepartment, setFilterDepartment] = useState('all')
  const [filterYear, setFilterYear] = useState('all')
  const [filterInspectionRound, setfilterInspectionRound] = useState('all')

  const [filterExport, setFilterExport] = useState('')
  const [searchQuery, setSearchQuery] = useState('');

  const [findOverviewTable, setFindOverviewTable] = useState(null)
  const [pageOverviewTable, setPageOverviewTable] = useState(1)
  const [rowsPerPageOverviewTable, setRowsPerPageOverviewTable] = useState(10)


  const [findChecklist, setFindChecklist] = useState([])
  const [configHead, setConfigHead] = useState([
    { name: "ปี", minWidth: "65px", align: 'left' },
    { name: "รอบการตรวจ", minWidth: "125px", align: 'left' },
    { name: "ชื่อ นามสกุล", minWidth: "220px", align: 'left' },
    { name: "สังกัด", minWidth: "60px", align: 'left' }

  ])
  const [configBody, setConfigBody] = useState([
    { name: 'year', align: 'center',type:'year' },
    { name: 'inspection_round', align: 'center' },
    { name: 'full_name', align: 'left' },
    { name: 'department_name_short', align: 'left' }

  ])


  useEffect(() => {
    fetchData()
  }, [])


  useEffect(() => {
    fetchDataImport()
  }, [filterYear, filterDepartment, filterHospital, filterInspectionRound, pageOverviewTable, rowsPerPageOverviewTable])



  useEffect(() => {
    if (searchQuery.length === 0) {
      setSearchQuery('')
      fetchDataImport()
    }

  }, [searchQuery])

  // useEffect(() => {
  //   console.log("searchQuery : ",searchQuery,searchQuery.length);

  //   if (searchQuery && searchQuery.length === 0) {
  //     console.log("process");

  //     fetchDataImport(searchQuery)
  //   }
  // }, [searchQuery])



  useEffect(() => {

    if (['EXCEL'].includes(filterExport)) {

      let year = filterYear === 'all' ? '' : filterYear
      let hospital_code = filterHospital === 'all' ? '' : filterHospital
      let department_code = filterDepartment === 'all' ? '' : filterDepartment

      let status = handleExportExcel('ex-0001', {
        year: year,
        hospital_code: hospital_code,
        department_code: department_code

      }, `excel-ข้อมูลนำเข้าผลตรวจสุขภาพ`)
      if (status) {
        setFilterExport('null')
        setFilterDepartment('all')
        setFilterHospital('all')
        setFilterYear('all')

      }

    }

  }, [filterExport])


  const fetchDataImport = async (search) => {

    let accessToken = localStorage.getItem('AccessToken')
    ApiImportHistory({
      year: filterYear,
      inspection_round: filterInspectionRound,
      dep_code: filterDepartment,
      hospital_code: filterHospital,
      limit: rowsPerPageOverviewTable,
      page: pageOverviewTable,
      search: search
    }, accessToken).then(res => {
      if (res.status) {
        setFindOverviewTable(res)
      } else {
        setFindOverviewTable(null)
      }
    })
  }


  const fetchData = async () => {

    ApiFindHospital({ doc_status: 'W' }).then(res => {
      if (res && res.length > 0) {
        setFindHospital(res)
      } else {
        setFindHospital([])
      }
    })

    ApiFindDropdown('year').then(res => {
      if (res.status) {
        setFindYear(res.data)
      } else {
        setFindYear([])
      }
    })

    ApiFindDropdown('inspection_round').then(res => {
      if (res.status) {
        setFindInspectionRound(res.data)
      } else {
        setFindInspectionRound([])
      }
    })

    ApiFindDropdown('file_export', { i_code: "EXCEL" }).then(res => {
      if (res.status) {
        setFindExport(res.data)
      } else {
        setFindExport([])
      }
    })

    ApiFindDepartment({ doc_status: 'W' }).then(res => {
      if (res && res.length > 0) {
        setFindDepartment(res)
      } else {
        setFindDepartment([])
      }
    })


    ApiFindCheckList().then(res => {
      if (res && res.length > 0) {
        res.forEach(element => {
          configHead.push({ name: element.field_name, minWidth: "140px", align: 'center' })
          configBody.push({ name: element.field, align: 'center' })
        });
        setConfigHead(configHead)
        setConfigBody(configBody)
        setFindChecklist(res)
      } else {
        setFindChecklist([])
      }
    })
  }


  const handleExportExcel = async (excel_code, filter, file_name) => {

    let result = await ApiExportExcel({
      "export_code": excel_code,
      "file_name": file_name,
      "filter": filter
    })

    if (result?.status) {

      let { file_url } = result.data

      // Create a hidden anchor element for downloading the file
      const link = document.createElement('a');
      link.href = file_url;
      link.download = ''; // Optional: specify a custom filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      return true

    } else {
      return false

    }





  }

  const handleFileImport = (event) => {
    const file = event.target.files[0];
    if (file) {
      const allowedExtensions = ['xlsx', 'xls'];
      const fileExtension = file.name.split('.').pop().toLowerCase();

      if (!allowedExtensions.includes(fileExtension)) {
        setErrorMessage('กรุณาอัปโหลดไฟล์ Excel (.xlsx หรือ .xls)');
        setFileName('');
        setFile(null)
      } else {
        setErrorMessage('');
        setFileName(file.name); // Set uploaded file name
        setFile(file)
      }
    }
  };

  const handleClearFile = () => {
    setFileName(''); // Clear file name
    setErrorMessage(''); // Clear error message
  };






  const handleChange = (type, e) => {

    if (type === 'filter_department') {
      setFilterDepartment(e.target.value)
      // setErrorMessage('')
    } if (type === 'filter_hospital') {
      setFilterHospital(e.target.value)
      // setErrorMessage('')
    } else if (type === 'filter_year') {
      setFilterYear(e.target.value)
      // setErrorMessage('')
    } else if (type === 'filter_inspection_round') {
      setfilterInspectionRound(e.target.value)
      // setErrorMessage('')
    } else if (type === 'filter_export') {
      setFilterExport(e.target.value)
      // setErrorMessage('')
    } else if (type === 'hospital') {
      setHospital(e.target.value)
      // setErrorMessage('')
    }
  }




  const handleSearch = () => {
    fetchDataImport(searchQuery)
  }

  const handleDownloadTemplate = async () => {

    try {
      // Fetch document details
      let result = await ApiFindDocument({ document_code: "DOC-000" });
      if (result && result.document_endpoint) {
        const fileUrl = result.document_endpoint;
        // Create a hidden anchor element for downloading the file
        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = ''; // Optional: specify a custom filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        console.error("Document endpoint not found");
      }
    } catch (error) {
      console.error("Error downloading template:", error);
    }


  }


  const handleUploadFile = async () => {


    if (!hospital) {
      // alert('กรุณาเลือกโรงพยาบาล')
      // setErrorMessage('กรุณาเลือกโรงพยาบาล')
      setMessageAlert('กรุณาเลือกโรงพยาบาล')
      handleOpenAlert(true)
      setAlertType('error')

    } else if (!file) {
      // alert('กรุณาเลือกไฟล์')
      // setErrorMessage('กรุณาเลือกไฟล์')
      setMessageAlert('กรุณาเลือกไฟล์')
      handleOpenAlert(true)
      setAlertType('error')


    } else {
      setLoading(true)
      let result = await ApiUploadExcel(hospital, file)
      if (result.status) {

        setLoading(false)
        fetchDataImport()
        setMessageAlert('นำเข้าไฟล์สำเร็จ')
        setAlertType('success')
        handleOpenAlert(true)
        setErrorMessage('');
        setFileName('');
        setFile(null)
        setAlertData([])
        setTimeout(() => {

          handleOpenAlert(false)
          setMessageAlert('')
          setAlertType('')
        }, 2000);


      } else {
        // alert('นำเข้าไฟล์ไม่สำเร็จ')
        setLoading(false)
        setMessageAlert('นำเข้าไฟล์ไม่สำเร็จกรุณาตรวจสอบ')
        setAlertType('error')
        handleOpenAlert(true)
        setAlertData(result.data)
      }

    }


  }


  const handlemore = (type, payload) => {
    if (type === 'VIEW') {
      window.open(`https://microservice-smarthealth.mod.go.th/healthsystem-uat-report/documents/checkup/?doc_code=EL-11&pid=${payload.pid}`, '_blank')

    } else if (type === 'EDIT') {
      navigate(`/editPersonalHealthData/?pid=${payload.pid}&year=${payload.year}&inspection_round=${payload.inspection_round}&department_code=${payload.department_code}&hospital_code=${payload.hospital_code}&type=${type}`);
      // window.open(`/editPersonalHealthData/?pid=${payload.pid}&year=${payload.year}&inspection_round=${payload.inspection_round}&type=${type}`, '_blank')
    } else if (type === 'DELETE') {

      setDataSubmit({
        pid: payload.pid,
        year: payload.year,
        inspection_round: payload.inspection_round,
        department_code: payload.department_code,
        hospital_code: payload.hospital_code,
      })
      handleOpenSubmit(true, false)
      setTypeSubmit('ยืนยันการลบ ?')
      // window.open(`/editPersonalHealthData/?pid=${payload.pid}&year=${payload.year}&inspection_round=${payload.inspection_round}&type=${type}`, '_blank')

    }
  }


  const handleAlert = () => {

  }




  return (

    <>
      <Box>
        <Box sx={{ display: 'grid', gridGap: '10px' }}>
          <Box sx={{ color: '#478F96', fontSize: 18, fontWeight: 600 }}>นำเข้าข้อมูลสุขภาพ</Box>
          <Box sx={{ fontSize: 16 }}>เตรียมข้อมูลสุขภาพด้วยไฟล์ต้นแบบ (Excel)</Box>
        </Box>

        <Box
          sx={{
            border: '1px solid #478F96',
            borderRadius: '8px',
            padding: 2,
            marginTop: 2,
          }}
        >
          {/* Hospital Selection and Download Template Button */}
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {/* Hospital Selection and Download Template Button */}
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'center', width: '70%' }}>
              <Box sx={{ flexGrow: 1 }}>
                <Box sx={{ fontWeight: 600 }}>เลือกโรงพยาบาลที่ตรวจ</Box>
                <Select
                  fullWidth
                  displayEmpty
                  defaultValue=""
                  sx={{ height: '50px' }}
                  onChange={(e) => { handleChange('hospital', e) }}
                >
                  <MenuItem value="" disabled>เลือกโรงพยาบาล</MenuItem>
                  {findHospital && findHospital.length > 0 ? findHospital.map(d => (<MenuItem value={d.hospital_code}>{d.hospital_name}</MenuItem>)) : null}
                </Select>
              </Box>
              <Box sx={{ minWidth: '150px', flexShrink: 0 }}>
                <Box sx={{ fontWeight: 600 }}>ดาวน์โหลดไฟล์ต้นแบบ</Box>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: '#478F96',
                    borderRadius: '12px',
                    height: '50px',
                    fontWeight: 600,
                    width: '100%',
                  }}
                  onClick={handleDownloadTemplate}
                >
                  ดาวน์โหลด
                </Button>
              </Box>
            </Box>

            {/* File Import Section */}
            <Box sx={{ fontWeight: 600 }}>แนบไฟล์นำเข้า (Excel)</Box>
            <Box sx={{ marginBottom: 2, display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center', width: '70% ' }}>
              {fileName && fileName.length > 0 ? <TextField
                sx={{ flexGrow: 1 }}
                value={fileName}
                InputProps={{
                  readOnly: true,
                  endAdornment: fileName && (
                    <InputAdornment position="end">
                      <IconButton onClick={handleClearFile}>
                        <DeleteIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              /> : null}
              <Box sx={{ minWidth: '150px', flexShrink: 0 }}>

                {fileName && fileName.length > 0 ? <Button
                  variant="contained"
                  component="label"
                  sx={{
                    backgroundColor: '#478F96',
                    borderRadius: '12px',
                    height: '50px',
                    fontWeight: 600,
                    width: '100%',
                  }}
                  onClick={handleUploadFile}
                >
                  นำเข้าข้อมูล

                </Button> : <Button
                  variant="contained"
                  component="label"
                  sx={{
                    backgroundColor: '#478F96',
                    borderRadius: '12px',
                    height: '50px',
                    fontWeight: 600,
                    width: '100%',
                  }}
                >
                  เลือกไฟล์นำเข้า
                  <input
                    type="file"
                    accept=".xlsx"
                    hidden
                    onChange={handleFileImport}
                  />
                </Button>}

              </Box>
            </Box>
          </Box>

          {errorMessage && <Alert severity="error">{errorMessage}</Alert>}

        </Box>

        <Box
          sx={{
            border: '1px solid #478F96',
            borderRadius: '8px',
            padding: 2,
            marginTop: 2,
            // height: '100vh',
            height: 'auto',
            overflow: 'auto'
          }}
        >

          {/* Search Section */}
          <Box sx={{ marginBottom: 1 }}>
            <Box sx={{ fontWeight: 600 }}>ข้อมูลที่นำเข้าแล้ว</Box>
            <SearchBar
              label="ค้นหาด้วยชื่อ/ เลขบัตรประชาชน"
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              handleSearch={handleSearch}
            />
          </Box>

          <Box
            sx={{
              display: 'flex',
              flexDirection: isSmallScreen ? 'column' : 'row',
              gap: '10px',
              marginBottom: 2,
            }}
          >
            {/* Left Section: Adjusts to full width on small screens */}
            <Box
              sx={{
                flex: isSmallScreen ? '1' : '4',
                display: 'flex',
                flexDirection: isSmallScreen ? 'column' : 'row',
                gap: '10px',
              }}
            >
              {/* Year Select */}
              <Box>
                <Box sx={{ fontWeight: 600 }}>เลือกปี</Box>
                <Select
                  size="small"
                  value={filterYear || 'null'}
                  onChange={(e) => handleChange('filter_year', e)}
                  sx={selectStyles}
                >
                  <MenuItem value="null" disabled>
                    เลือกปี
                  </MenuItem>
                  <MenuItem value="all">ทั้งหมด</MenuItem>
                  {findYear.map((i, idx) => (
                    <MenuItem key={idx} value={i.i_code}>
                      {i.i_name}
                    </MenuItem>
                  ))}
                </Select>
              </Box>

              {/* Inspection Round Select */}
              {/* <Box>
                <Box sx={{ fontWeight: 600 }}>เลือกรอบตรวจ</Box>
                <Select
                  size="small"
                  value={filterInspectionRound || 'null'}
                  onChange={(e) => handleChange('filter_inspection_round', e)}
                  sx={selectStyles}
                >
                  <MenuItem value="null" disabled>
                    เลือกรอบตรวจ
                  </MenuItem>
                  <MenuItem value="all">ทั้งหมด</MenuItem>
                  {findInspectionRound.map((d, idx) => (
                    <MenuItem key={idx} value={d.i_code}>
                      {d.i_name}
                    </MenuItem>
                  ))}
                </Select>
              </Box> */}

              {/* Hospital Select */}
              <Box>
                <Box sx={{ fontWeight: 600 }}>เลือกโรงพยาบาล</Box>

                <Select
                  size="small"
                  value={filterHospital || 'null'}
                  onChange={(e) => handleChange('filter_hospital', e)}
                  sx={selectStyles}
                >
                  <MenuItem value="null" disabled>
                    เลือกโรงพยาบาล
                  </MenuItem>
                  <MenuItem value="all">ทั้งหมด</MenuItem>
                  {findHospital.map((d, idx) => (
                    <MenuItem key={idx} value={d.hospital_code}>
                      {d.hospital_name}
                    </MenuItem>
                  ))}
                </Select>
              </Box>

              {/* Department Select */}
              <Box >
                <Box sx={{ fontWeight: 600 }}>เลือกหน่วย/ สังกัด</Box>

                <Select
                  size="small"
                  value={filterDepartment || 'null'}
                  onChange={(e) => handleChange('filter_department', e)}
                  sx={selectStyles}
                >
                  <MenuItem value="null" disabled>
                    เลือกหน่วย/ สังกัด
                  </MenuItem>
                  <MenuItem value="all">ทั้งหมด</MenuItem>
                  {findDepartment.map((d, idx) => (
                    <MenuItem key={idx} value={d.department_code}>
                      {d.department_name}
                      {d.department_name_short && ` (${d.department_name_short})`}
                    </MenuItem>
                  ))}
                </Select>
              </Box>

            </Box>

            {/* Right Section: Adjusts to full width on small screens */}
            <Box
              sx={{
                flex: isSmallScreen ? '1' : '1',
                display: 'flex',
                justifyContent: isSmallScreen ? 'flex-start' : 'flex-end',
              }}
            >
              <Box>
                <Select
                  size="small"
                  value={filterExport || 'null'}
                  onChange={(e) => handleChange('filter_export', e)}
                  sx={selectStyles}
                >
                  <MenuItem value="null" disabled>
                    Export
                  </MenuItem>
                  {findExport.map((d, idx) => (
                    <MenuItem key={idx} value={d.i_code}>
                      {d.i_name}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
            </Box>
          </Box>


          <Box sx={{}}>


            {findChecklist && findChecklist.length > 0 ? <>
              <TableCustom
                data={{
                  data: findOverviewTable?.data,
                  pagging: findOverviewTable?.pagging
                }}
                // onSelected
                // selected={select}
                // setSelected={handleSelect}
                // handlemore
                more={true}
                listMore={['EDIT', 'DELETE']}
                handlemore={handlemore}

                page={pageOverviewTable}
                setPage={setPageOverviewTable}
                rowsPerPage={rowsPerPageOverviewTable}
                setRowsPerPage={setRowsPerPageOverviewTable}
                pagination={true}
                sx={{ height: "100%" }}
                head={configHead}
                body={configBody}
                showNoData={false}
              />


            </>
              : <Nodata />}



          </Box>


        </Box>

      </Box>

      <DialogAlert
        loading={loading}
        title={'แจ้งเตือน'}
        type={alertType}
        message={messageAlert}
        open={openAlert}
        setOpen={setOpenAlert}
        handleChange={handleAlert}
        data={alertData}

      />

      <DialogSubmit
        title={`${typeSubmit}`}
        open={openSubmit}
        setOpen={setOpenSubmit}
        handleOpenSubmit={handleOpenSubmit}
        data={dataSubmit}
      />
    </>
  );
}

export default ImportHealthData;
